import { render, staticRenderFns } from "./KidneyMedicalDetails.vue?vue&type=template&id=31153c9c"
import script from "./KidneyMedicalDetails.vue?vue&type=script&lang=js"
export * from "./KidneyMedicalDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports